<template>
  <div class="wrapper">
    <div class="info head">
      <span class="label">头像：</span>
      <div class="r">
        <div class="user-head">
          <input
            type="file"
            class="input-file"
            name="avatar"
            ref="avatarInput"
            @change="changeImage($event)"
            accept="image/gif, image/jpeg, image/jpg, image/png"
          >
          <img :src="userImage" alt v-loading="loadingShow">
          <div class="change">更换头像</div>
        </div>
      </div>
    </div>
    <div class="info">
      <span class="label">昵称：</span>
      <div class="r">
        <input type="text" placeholder="请输入昵称" v-model="userName" class="info-input">
      </div>
    </div>
    <div class="info">
      <span class="label">性别：</span>
      <div class="r">
        <el-radio v-model="sex" :label="1">男</el-radio>
        <el-radio v-model="sex" :label="2">女</el-radio>
      </div>
    </div>
    <div class="info">
      <span class="label">生日：</span>
      <div class="r">
        <el-date-picker v-model="birthday" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
      </div>
    </div>
    <div class="save" @click="saveInfo">保存</div>
  </div>
</template>

<script>
import { apiBaseUrl } from "@/config/env.js";
export default {
  name: "UserInfo",
  components: {},
  props: {},
  data() {
    return {
      userInfo: {},
      userImage: "",
      userName: "",
      sex: 0,
      birthday: "",
      upLoadUrl: apiBaseUrl + "api.html",
      loadingShow: false
    };
  },
  watch: {},
  computed: {},
  methods: {
    saveInfo() {
      let data = {
        sex: this.sex,
        birthday: this.birthday,
        nickname: this.userName
      };
      this.$api.editInfo(data).then(res => {
        if (res.status) {
          this.$msg(res.msg);
          this.getUserInfo();
        } else {
          this.$msg(res.msg, "error");
        }
      });
    },
    changeImage(e) {
      this.loadingShow = true;
      let file = e.target.files[0];
      var formdata = new FormData();
      formdata.append("upfile", file, file.name);
      this.$api.uploadImage(this.upLoadUrl, formdata).then(res => {
        if (res.status) {
          let data = {
            avatar: res.data.url
          };
          this.$api.changeAvatar(data).then(r => {
            if (r.status) {
              this.$msg(r.msg);
              this.userImage = r.data.avatar;
            } else {
              this.$msg(r.msg, "error");
            }
          });
        } else {
          this.$msg(res.msg, "error");
        }
        this.loadingShow = false;
      });
    },
    getUserInfo() {
      this.$api.userInfo().then(result => {
        if (result.status) {
          this.userInfo = result.data;
          this.userImage = this.userInfo.avatar;
          this.userName = this.userInfo.nickname;
          this.sex = this.userInfo.sex;
          this.birthday = this.userInfo.birthday;
        }
      });
    }
  },
  created() {},
  mounted() {
    this.getUserInfo();
  }
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/variable.scss";
.wrapper {
  .save {
    width: 120px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background: $theme-color;
    color: #fff;
    margin-left: 80px;
    margin-top: 30px;
    cursor: pointer;
  }
  .info {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    &.head {
      align-items: flex-start;
      .label {
        padding-top: 10px;
      }
    }
    .label {
      display: inline-block;
      width: 60px;
      margin-right: 20px;
    }
    .r {
      .user-head {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        position: relative;
        &:hover {
          .change {
            display: block;
          }
        }
        .input-file {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          opacity: 0;
          cursor: pointer;
          z-index: 99;
        }
        .change {
          display: none;
          position: absolute;
          top: 50%;
          left: 50%;
          width: 70px;
          height: 18px;
          margin-left: -35px;
          line-height: 18px;
          text-align: center;
          margin-top: -8px;
          background: #757575;
          color: #fff;
          cursor: pointer;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .info-input {
        width: 160px;
        height: 24px;
        line-height: 24px;
        border: 1px solid $border;
        padding-left: 12px;
      }
    }
  }
}
</style>